import * as React from 'react';

function SvgFilterProgress(props) {
  return (
    <svg width={12} height={14} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.098.858a.512.512 0 01.512.512.502.502 0 01-.287.45A4.61 4.61 0 018.11 7.518a4.61 4.61 0 012.5 4.098c.01.164.01.328 0 .492a.512.512 0 01.512.533.512.512 0 01-.532.512h-9.2a.512.512 0 01-.513-.512.512.512 0 01.513-.533 3.963 3.963 0 010-.492 4.61 4.61 0 012.5-4.098 4.61 4.61 0 01-2.214-5.686.512.512 0 01.225-.973zM6.03 8.029a3.586 3.586 0 00-3.586 3.586c-.01.164-.01.328 0 .492h7.11a3.84 3.84 0 00.061-.492A3.586 3.586 0 006.031 8.03zm3.206-6.147H2.762a3.586 3.586 0 106.475 0zm-.594 3.115a3.074 3.074 0 01-5.286 0z" />
    </svg>
  );
}

export default SvgFilterProgress;
